import moment from "moment";
import axios from "axios";
import { canParseJson, getTokenHeader } from "./commonHelper.js";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export function getUserFromLocalStorage() {
  const storageItem = localStorage.getItem("session");
  if (canParseJson(storageItem)) {
    const session = JSON.parse(storageItem),
      expires = moment(session?.expires);
    if (!session || moment(session?.expires).isBefore(moment())) {
      localStorage.removeItem("authRefreshToken");
      localStorage.removeItem("session");
      return null;
    } else if (expires.isAfter(moment()))
      return { id: session.user_id, expires: session.expires };
    else return null;
  } else return null;
}

export async function getUserById(id) {
  const headers = getTokenHeader();
  if (id && headers) {
    try {
      const response = await axios.get(`${env.auth_api_client_url}users/find`, {
        params: { id },
        headers
      });
      return response?.data?.data?.[0];
    } catch (ex) {
      throw new Error(`API Error: ${ex}`);
    }
  } else if (!id) throw new Error("API Error: No id passed");
  else throw new Error("Not Authorised");
}

export async function getUsersByPrincipalId(id) {
  const headers = getTokenHeader();
  if (id && headers) {
    try {
      const response = await axios.get(`${env.auth_api_client_url}users/find`, {
        params: { principal: id },
        headers
      });
      return response?.data?.data;
    } catch (ex) {
      throw new Error(`API Error: ${ex}`);
    }
  } else if (!id) throw new Error("API Error: No principal-id passed");
  else throw new Error("Not Authorised");
}
